import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover, Button } from 'react-bootstrap/lib';
import { getTotalProfilesAnalyzed } from '../../lib/formatters';
import EmployeeCompanyDataItem from './EmployeeCompanyDataItem';

export default class SurveyProfileAnalyzed extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    dropdownOnJobMatchCard: PropTypes.bool,
    isMP: PropTypes.bool,
    jobDetails: PropTypes.object,
    saveProfilesAnalyzed: PropTypes.func,
    surveyRow: PropTypes.object
  };

  static defaultProps = {
    disabled: false
  };

  constructor(props) {
    super(props);
  }

  getProfilesAnalyzedLabel(totalProfilesAnalyzed) {
    return (
      <div className="totalProfilesAnalyzed__container">
        <span className="totalProfilesAnalyzed dropdown__btn--label">Profiles Analyzed:</span>
        <span className="profile-analyzed__dropdown--btn">
          {' ' + totalProfilesAnalyzed}
          <i className="icon-sort-down" />
        </span>
      </div>
    );
  }

  getPopoverLabel(totalProfilesAnalyzed) {
    const { isMP, jobDetails, surveyRow } = this.props;

    let profilesAnalyzedLabel = this.getProfilesAnalyzedLabel(totalProfilesAnalyzed);
    let label = surveyRow ? (
      <EmployeeCompanyDataItem companyData={surveyRow} isMP={isMP} isPayscaleRow={true} companyDataInDropdown={false} />
    ) : (
      ''
    );

    if (
      jobDetails &&
      jobDetails.details &&
      jobDetails.details.payscale_job_info &&
      jobDetails.details.payscale_job_info.saveProfilesAnalyzed
    ) {
      const saveProfilesAnalyzed = jobDetails.details.payscale_job_info.saveProfilesAnalyzed;

      if (saveProfilesAnalyzed === 'profilesAnalyzed') {
        label = profilesAnalyzedLabel;
      }

      if (saveProfilesAnalyzed === 'companyEmployeeData') {
        return label;
      }
    }

    return label;
  }

  getPopoverContent(totalProfilesAnalyzed) {
    const { isMP, surveyRow } = this.props;

    return (
      <Popover id="popover-positioned-bottom" className="totalProfilesPopover">
        <span>
          <div className="div--profiles" onClick={this.clickProfiles.bind(this)}>
            <span>Profiles Analyzed: {totalProfilesAnalyzed}</span>
          </div>

          {surveyRow ? (
            <div className="div--companies" onClick={this.clickCompanies.bind(this)}>
              <EmployeeCompanyDataItem
                companyData={surveyRow}
                isMP={isMP}
                isPayscaleRow={true}
                companyDataInDropdown={true}
              />
            </div>
          ) : (
            ''
          )}
        </span>
      </Popover>
    );
  }

  clickProfiles() {
    const { jobDetails, saveProfilesAnalyzed } = this.props;
    if (jobDetails && jobDetails.jobIdList && jobDetails.jobIdList.length > 0) {
      const id = jobDetails.jobIdList[0];
      saveProfilesAnalyzed(id, 'profilesAnalyzed');
      this.popover.hide();
    }
  }

  clickCompanies() {
    const { jobDetails, saveProfilesAnalyzed } = this.props;
    if (jobDetails && jobDetails.jobIdList && jobDetails.jobIdList.length > 0) {
      const id = jobDetails.jobIdList[0];
      saveProfilesAnalyzed(id, 'companyEmployeeData');
      this.popover.hide();
    }
  }

  render() {
    const { surveyRow, dropdownOnJobMatchCard, disabled } = this.props;
    let totalProfilesAnalyzed = getTotalProfilesAnalyzed(surveyRow);

    let label = this.getPopoverLabel(totalProfilesAnalyzed);

    const popoverBottom = this.getPopoverContent(totalProfilesAnalyzed);

    const buttonClass = dropdownOnJobMatchCard ? 'profile-analyzed__popover--btn' : '';

    return (
      <div className="profile-analyzed__popover-container survey__dropdowns">
        <OverlayTrigger
          container={this}
          trigger="click"
          placement="bottom"
          ref={ref => (this.popover = ref)}
          overlay={popoverBottom}
          rootClose
          disabled={disabled}
        >
          <Button className={buttonClass}>{label}</Button>
        </OverlayTrigger>
      </div>
    );
  }
}
